// extracted by mini-css-extract-plugin
export default {"wrapper":"TreeNodeTitleWrapper-module__wrapper___SofMQ"};